
import productDisclaimerQuery from '~/apollo/queries/disclaimer/disclaimer.gql';

export default {
  name: 'ProductDisclaimer',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },

  apollo: {
    disclaimers: {
      query: productDisclaimerQuery,
      prefetch: true,
      variables() {
        return {
          disclaimer_type: 'decoder-detail-bottom',
          locale: this.currentLocale,
        };
      },
      update(data) {
        return this.$normalizeStrapi(data.blogDisclaimers.data);
      },
    },
  },
  data() {
    return {
      currentLocale: this.$normalizeLocale(this.$i18n.locale),
    };
  },
};
